import React from "react";
import MergeTable from "../../../../shared/MergeTable";
import { SkeletonLoader } from "@merge-api/merge-javascript-shared";

const AuditLogsLoadingStateTable = () => {
  return (
    <>
      <MergeTable
        hasMorePaddingOnFirstElement
        hover={false}
        header={
          <>
            <th scope="col">User</th>
            <th scope="col">Role</th>
            <th scope="col">Event description</th>
            <th scope="col">IP address</th>
            <th scope="col">Date</th>
          </>
        }
        content={Array.from({ length: 8 }).map((_, index) => (
          <tr key={`skeleton-row-${index}`}>
            <td colSpan={5}>
              {/* 44 is the two-line User cell a loaded row shows (24px h6 + 20px sm) */}
              <SkeletonLoader height={44} borderRadius={8} fullWidth />
            </td>
          </tr>
        ))}
      />
    </>
  );
};

export default AuditLogsLoadingStateTable;
